// The curated table of contents for the in-app manual. Ordering and grouping live
// HERE; each topic's title + blurb are derived from its markdown file (see
// help-content.ts). To add a topic: drop a `content/<slug>.md` file and add its
// slug to a group below.

export interface HelpGroup {
  label: string;
  slugs: string[];
}

export const HELP_GROUPS: HelpGroup[] = [
  {
    label: 'Getting started',
    slugs: ['getting-started'],
  },
  {
    label: 'Selling',
    slugs: [
      'cashier-sale',
      'placing-orders',
      'availability',
      'cash-register',
      'split-payment',
      'store-credit-at-till',
      'cancel-orders',
      'refunds',
      'sales-history',
      'offline-sales',
      'loyalty',
    ],
  },
  {
    label: 'Trading day, shifts & cash',
    slugs: ['day-open-close', 'shifts', 'register-lock', 'cash-drawer'],
  },
  {
    label: 'Stock & suppliers',
    slugs: [
      'stock-items',
      'stock-take',
      'receiving-deliveries',
      'suppliers',
      'reorder-helper',
    ],
  },
  {
    label: 'Menu',
    slugs: ['menu-management', 'menu-publish'],
  },
  {
    label: 'Reports & monitoring',
    slugs: ['dashboard', 'reports'],
  },
  {
    label: 'Owner & admin',
    slugs: ['admin', 'staff'],
  },
  {
    label: 'Troubleshooting',
    slugs: ['troubleshooting'],
  },
];

// Every slug, in table-of-contents order - used for prev/next on a topic page and
// to flag any content file that is missing from the manifest (build-time check in
// the index page).
export function orderedHelpSlugs(): string[] {
  return HELP_GROUPS.flatMap((g) => g.slugs);
}
